import { useMemo, useState } from 'react';
import { Label, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { ReactComponent as AddIcon } from '../../../../../assets/utils/images/svgs/Add.svg';
import { ReactComponent as SearchIcon } from '../../../../../assets/utils/images/svgs/search.svg';
import Loader from 'react-loaders';

const AfasGebruikerModal = ({
    setModal,
    modal,
    candidates = [],
    onAdd,
    isLoading = false,
}) => {
    const [search, setSearch] = useState('');

    const filteredData = useMemo(() => {
        if (search.trim() === '') {
            return candidates;
        }

        const searchValue = search.toLowerCase();

        return candidates.filter(
            (item) =>
                item?.name?.toLowerCase()?.includes(searchValue) ||
                String(item?.iAdminId)?.includes(searchValue),
        );
    }, [search, candidates]);

    const toggleModal = () => {
        setModal((prev) => ({ ...prev, state: !prev.state }));
        setSearch('');
    };

    return (
        <Modal
            isOpen={modal.state}
            toggle={toggleModal}
            className="feedback-modal-style link-form modal-centered"
        >
            <ModalHeader toggle={toggleModal}>Selecteer Salaris gebruiker</ModalHeader>
            <ModalBody className="pb-5">
                {isLoading ? (
                    <Loader
                        type="ball-grid-pulse"
                        className="mt-3 d-flex mx-auto justify-content-center"
                    />
                ) : candidates.length > 0 ? (
                    <>
                        <div className="pb-4 mt-3 melder-search">
                            <input
                                placeholder="Zoeken"
                                value={search}
                                onChange={(event) => setSearch(event.target.value)}
                            />
                            <SearchIcon />
                        </div>

                        <div className="melder-list">
                            {filteredData.length > 0 ? (
                                filteredData.map((item) => (
                                    <div className="py-2 melder-li" key={item.iAdminId}>
                                        <Label for={`afas-user-${item.iAdminId}`}>
                                            {item.name}
                                        </Label>
                                        <AddIcon
                                            className="cursor-pointer"
                                            onClick={() => onAdd?.(item.iAdminId)}
                                        />
                                    </div>
                                ))
                            ) : (
                                <p className="text-center mt-3">Geen resultaten gevonden.</p>
                            )}
                        </div>
                    </>
                ) : (
                    <p className="text-center mt-3">Geen kandidaten beschikbaar.</p>
                )}
            </ModalBody>
        </Modal>
    );
};

export default AfasGebruikerModal;
